/**
 * bsautosuggest Module Entry Point
 *
 * Import styles and JS, expose functions globally for OXID frontend usage.
 */

// Import styles first
import '../scss/bsautosuggest.scss';

// Import all exports from the main module
import * as BSAutosuggest from '../js/bsautosuggest.js';

// Expose all functions globally on window object
if (typeof window !== 'undefined') {
    // Expose each function individually
    Object.keys(BSAutosuggest).forEach(key => {
        window[key] = BSAutosuggest[key];
    });
}
